import mount from "../utils/mount";
import Template2013Container from "./Template2013Container";

import "./css/all.css";
import "./css/custom.css";

mount(Template2013Container);
